import { render, staticRenderFns } from "./ScreenEditor.vue?vue&type=template&id=3c70093f&scoped=true&"
import script from "./ScreenEditor.vue?vue&type=script&lang=js&"
export * from "./ScreenEditor.vue?vue&type=script&lang=js&"
import style0 from "./ScreenEditor.vue?vue&type=style&index=0&id=3c70093f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c70093f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3c70093f', component.options)
    } else {
      api.reload('3c70093f', component.options)
    }
    module.hot.accept("./ScreenEditor.vue?vue&type=template&id=3c70093f&scoped=true&", function () {
      api.rerender('3c70093f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/ScreenEditor/ScreenEditor.vue"
export default component.exports